import React from 'react';

import HeaderView from '../../views/header/HeaderView.js';

import * as Auth from '../../services/Auth.Service.js';


export class HeaderComponent extends React.Component {

    /**
     * Class constructor.
     * @argument {object} props
     */
    constructor(props) {
	super(props);

	// set the initial component state
	this.state = {
	  
	};
    }

    componentWillMount() {
    }

    

    /**
     * Render the component.
     */
    render() {
	return (
		<HeaderView />
		);
    }

}


// WEBPACK FOOTER //
// ./src/client/components/header/HeaderComponent.js